// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7366120c","239":"d99803fe","453":"d855a71b","455":"4a97e243"}[chunkId] + ".chunk.js";
};